import { useSyncExternalStore } from 'react';

function hasMatchMedia(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

/**
 * SSR-safe media-query subscription. Returns `false` on the server and during
 * hydration so the first client paint matches server HTML (mobile-first body),
 * then the live match afterwards. Uses `useSyncExternalStore` so there is no
 * synchronous `setState` inside an effect (no wasted pre-paint render).
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onStoreChange: () => void): (() => void) => {
      if (!hasMatchMedia()) return (): void => {};
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onStoreChange);
      return (): void => {
        mq.removeEventListener('change', onStoreChange);
      };
    },
    (): boolean => (hasMatchMedia() ? window.matchMedia(query).matches : false),
    (): boolean => false,
  );
}
